import React from 'react';
import { Row, Col, Label } from 'reactstrap';
import { Field, ErrorMessage } from "formik";

const GamificationGraduation = () => {
    return (
        <>
            <div className="mb-4">
                <h5 className="fw-bold mb-1">Exames de Graduação</h5>
                <p className="text-muted mb-0 font-size-13">Requisitos e recompensas por evolução de nível.</p>
            </div>

            <Row className="g-3 mb-4">
                <Col md={4}>
                    <div className="p-3 border-top rounded-0 h-100">
                        <Label className="fw-bold text-dark small">Nota para Aprovação</Label>
                        <p className="text-muted font-size-11 mb-2">% mínima exigida no exame.</p>
                        <div className="input-group">
                            <Field type="number" className="form-control fw-bold rounded-0" name="minScoreToPassPercent" />
                            <span className="input-group-text fw-bold border-0 bg-white rounded-0">%</span>
                        </div>
                        <ErrorMessage name="minScoreToPassPercent" component="div" className="text-danger mt-1 font-size-12" />
                    </div>
                </Col>
                <Col md={4}>
                    <div className="p-3 border-top rounded-0 h-100">
                        <Label className="fw-bold text-dark small">Recompensa Aluno</Label>
                        <p className="text-muted font-size-11 mb-2">XP ao passar de faixa.</p>
                        <div className="input-group">
                            <Field type="number" className="form-control fw-bold rounded-0" name="xpRewardMemberPass" />
                            <span className="input-group-text bg-success text-white border-0 fw-bold rounded-0">XP</span>
                        </div>
                        <ErrorMessage name="xpRewardMemberPass" component="div" className="text-danger mt-1 font-size-12" />
                    </div>
                </Col>
                <Col md={4}>
                    <div className="p-3 border-top rounded-0 h-100">
                        <Label className="fw-bold text-dark small">Recompensa Professor</Label>
                        <p className="text-muted font-size-11 mb-2">XP que o professor ganha.</p>
                        <div className="input-group">
                            <Field type="number" className="form-control fw-bold rounded-0" name="xpRewardTeacherPass" />
                            <span className="input-group-text bg-info text-white border-0 fw-bold rounded-0">XP</span>
                        </div>
                        <ErrorMessage name="xpRewardTeacherPass" component="div" className="text-danger mt-1 font-size-12" />
                    </div>
                </Col>
            </Row>

            <div className="p-3 bg-warning bg-opacity-10 rounded-0 border border-warning border-opacity-25">
                <div className="d-flex align-items-start">
                    <div className="form-check form-switch form-switch-lg d-flex align-items-center mb-0 p-0">
                        <Field 
                            type="checkbox" 
                            name="requireFundamentalsMaxScore" 
                            id="requireFundamentalsMaxScore" 
                            className="form-check-input mt-0 me-3"
                            style={{ marginLeft: 0 }}
                        />
                        <Label 
                            className="form-check-label mb-0 fw-bold text-dark font-size-14" 
                            htmlFor="requireFundamentalsMaxScore"
                            style={{ cursor: "pointer" }}
                        >
                            Exigir Nota Máxima em Tópicos Fundamentais
                        </Label>
                    </div>
                </div>
                <p className="text-muted mt-2 mb-0 font-size-12 ms-5 ps-1">
                    Marque essa opção se deseja que o aluno passe de nível somente quando todos os tópicos marcados como fundamental estiverem com nota máxima.
                </p>
            </div>
        </>
    );
};

export default GamificationGraduation;
